var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "info_svg__info"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 5,
    y: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 5,
    y: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 0 6)"
  }))));
}
export default SvgInfo;